import React, { Fragment, useState } from 'react';
import { userImg } from '../../lib/constants';
import RecordsTable from './recordsTable';
import { useFetch } from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';
import { formatDate } from '../../lib/helpers';
import PostObject from '../../lib/postObject';

const userHeaders = ["Image", "User Name", "First", "Last", "email", "Created At"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) => {
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['image'] = obj.photo || userImg;
    trimmedObj['username'] = obj.username;
    trimmedObj['firstname'] = obj.firstName;
    trimmedObj['lastnname'] = obj.lastName;
    trimmedObj['email'] = obj.email;
    trimmedObj['createdAt'] = formatDate(new Date(obj.createdAt));
    trimmedObj['roles'] = obj.roles;
    return trimmedObj;
  }
  if (data) {
    return data.map(obj => getTrimmedObj(obj));
  }
  return [];
}

const Users = ({ openMainModal, location }) => {
  const getRole = () => {
    const paths = {
      '/users/shoppers': `role=Shopper`,
      '/users/travellers': `role=Traveller`,
      '/users/prime': `role=PrimeTraveller`,
      '/users/all': '',
    }
    return paths[location.pathname] || ''
  }

  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`users?page=${page}&${getRole()}&sort=createdAt:-1${searchParam}`, reload);

  const setTravellerAsPrime = (userID) => {
    PostObject('admins/primeTraveller', { usersIds: [userID] })
    toggleReload(r => !r)
  }

  return (
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={userHeaders}
        records={mapResponseData(data)}
        openMainModal={openMainModal}
        reload={() => toggleReload(r => !r)}
        setTravellerAsPrime={(userID) => setTravellerAsPrime(userID)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      />
      <PaginationBar page={page} totalCount={totalCount} setPage={setPage} />
    </Fragment>
  );
}
export default Users;